import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { GA_ACTION_COMPLETED } from './constants'
import {
  sendEvent,
  getAction,
  getValue,
} from './utils'

const WithInputAnalytics = category => (WrappedComponent) => {
  class WrappedInputComponent extends PureComponent {
    constructor(props) {
      super(props)
      this.startTime = null
      this.trackedCompleted = false
      this.trackedSkipped = false
    }

    componentDidMount() {
      const { value, options } = this.props
      // Track prefilled values - send completed event immediately
      // Except for radio fields
      if (options && options.length) {
        return
      }
      const name = this.getName(this.props)
      if (value && value.length) {
        sendEvent(name, GA_ACTION_COMPLETED, category)
        this.trackedCompleted = true
      }
    }

    onFocus = (...args) => {
      this.startTime = new Date().getTime()
      this.props.onFocus(...args)
    }
    onBlur = (e, ...rest) => {
      const name = this.getName(this.props)
      const value = getValue(e.currentTarget)
      const action = getAction(value)
      const elapsedTime = new Date().getTime() - this.startTime

      if (!this.trackedCompleted && action === GA_ACTION_COMPLETED) {
        sendEvent(name, action, category, undefined, elapsedTime, false)
        this.trackedCompleted = true
      } else if (!this.trackedSkipped && !this.trackedCompleted) {
        this.trackedSkipped = true
        sendEvent(name, action, category, undefined, elapsedTime, false)
      }
      this.props.onBlur(e, ...rest)
    }

    onChange = (e, ...rest) => {
      // Only track onChange for radio fields (ChoicField)
      if (this.props.options && this.props.options.length) {
        const name = this.getName(this.props)
        const value = getValue(e.currentTarget)
        const action = getAction(value)
        const elapsedTime = new Date().getTime() - this.startTime

        if (!this.trackedCompleted && action === GA_ACTION_COMPLETED) {
          sendEvent(name, action, category, undefined, elapsedTime, false)
          this.trackedCompleted = true
        }
      }
      this.props.onChange(e, ...rest)
    }

    getName = props => props.name || props.fieldName || props.id

    render() {
      const { onBlur, onChange, ...otherProps } = this.props
      return <WrappedComponent {...otherProps} onBlur={this.onBlur} onFocus={this.onFocus} onChange={this.onChange} />
    }
  }

  const name = WrappedComponent.displayName || WrappedComponent.name || 'Component'
  WrappedInputComponent.displayName = `withInputAnalytics(${name})`

  WrappedInputComponent.propTypes = {
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onChange: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  }

  WrappedInputComponent.defaultProps = {
    onBlur: f => f,
    onFocus: f => f,
    onChange: f => f,
    options: [],
    value: '',
  }
  return WrappedInputComponent
}

export default WithInputAnalytics



// WEBPACK FOOTER //
// ./hoc/WithInputAnalytics/index.jsx